module.exports = __webpack_public_path__ + "img/top.80cb7bac.png";